module.exports = __webpack_public_path__ + "static/media/cybersafekids.77d9c35c.png";